import { render } from "./TableComponent.vue?vue&type=template&id=6207f026&ts=true"
import script from "./TableComponent.vue?vue&type=script&lang=ts"
export * from "./TableComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__